<template>
  <section class="maintenancePage">
    <div class="maintenance loading" v-if="loading"></div>
    <div class="maintenance" :style="{'background-color': d.maintenanceBgColor,
      'background-image': `url(${d.maintenanceBg[lang]
      ? d.maintenanceBg[lang].imageLg : ''})`}" v-else>
      <div class="maintenanceOverlay" v-if="d.maintenanceBg[lang]"></div>
      <div class="maintenanceCnt">
        <div class="cnt">
          <div class="maintenanceContent" :style="{color: d.maintenanceTextColor}">
            <img class="logo" src="../assets/i-lead-logo.png">
            <h2>{{d.maintenanceTitle[lang]}}</h2>
            <p v-if="d.maintenanceDesc[lang]" v-html="d.maintenanceDesc[lang]"></p>
            <div class="langSelector">
              <div class="langItem" v-on:click="selectLang('id')"
                :style="{color: d.maintenanceTextColor}">Bahasa Indonesia</div>
              <div class="divider"
                :style="{'background-color': d.maintenanceTextColor}"></div>
              <div class="langItem" v-on:click="selectLang('en')"
                :style="{color: d.maintenanceTextColor}">English (US)</div>
            </div>
            <div class="btnCnt" v-if="d.maintenanceBtn">
              <a :href="d.maintenanceBtnUrl"
                class="btn primary">{{d.maintenanceBtnLabel[lang]}}</a>
            </div>
            <div class="socmedCnt" v-if="d.maintenanceSocmed && langData">
              <h4>{{langData.langs.footer_social_media.value}}</h4>
              <div class="comunityCnt">
                <li><a href="https://www.instagram.com/icel_indo/"
                  target="_blank" class="ig"></a></li>
                <li><a href="https://twitter.com/icel_indo?s=21"
                  target="_blank" class="tw"></a></li>
                <li><a href="https://youtube.com/c/IndonesianCenterforEnvironmentalLaw"
                  target="_blank" class="yt"></a></li>
                <li><a href="https://id.linkedin.com/company/indonesian-center-for-environmental-law"
                  target="_blank" class="li"></a></li>
                <li><a href="https://www.facebook.com/icel.or.id"
                  target="_blank" class="fb"></a></li>
                <li><a href="https://spoti.fi/3sGdvJP"
                  target="_blank" class="sp"></a></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'maintenance',
  components: {},
  data() {
    return {
      loading: true,
      d: null,
      socmed: null,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
      langData: null,
    };
  },
  computed: {},
  methods: {
    selectLang(langCode) {
      localStorage.setItem('portal_putusan_penting_icel_lang', langCode);
      window.location.reload();
    },
  },
  mounted() {
    this.lang = localStorage.getItem('portal_putusan_penting_icel_lang') || 'id';
    this.$http.get(this.$config.uri(`misc/lang/${this.lang}`)).then((rlang) => {
      this.langData = rlang.data.data;
    });

    /**
     * Get maintenance detail
     *
     */
    this.$http.get(this.$config.uri('config/section/maintenance')).then((r) => {
      this.loading = false;
      this.d = r.data.status === 200 ? r.data.data : null;
    });
  },
};
</script>

<style scoped lang="scss">
.maintenancePage{
  .maintenance{
    position: absolute;
    left: 0; right: 0; bottom: 0; top: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    &.loading{
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 46px auto;
    }
    .maintenanceOverlay{
      background-color: #000;
      position: absolute;
      left: 0; right: 0; bottom: 0; top: 0;
      opacity: .14;
      display: none;
    }
    .maintenanceCnt{
      width: 100%;
      position: relative;
      z-index: 7;
      .maintenanceContent{
        max-width: 780px;
        margin: 0 auto;
        text-align: center;
        color: #444;
        .logo{
          height: 46px;
          margin: 0 0 20px;
        }
        h2{
          font-size: 46px;
          margin: 0;
          @media (max-width: 1480px) {
            font-size: 36px;
          }
          @media (max-width: 640px) {
            font-size: 32px;
            line-height: 1.3;
            margin: 0 0 6px;
          }
        }
        p{
          margin: 0;
          font-size: 20px;
          line-height: 1.4;
          white-space: pre-wrap;
          @media (max-width: 1480px) {
            font-size: 18px;
          }
          @media (max-width: 640px) {
            font-size: 15px;
          }
        }
      }
      .langSelector{
        padding: 30px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .langItem{
          display: block;
          font-size: 17px;
          font-weight: 500;
          padding: 4px 10px;
          color: #444;
          cursor: pointer;
          @media (max-width: 1480px) {
            font-size: 15px;
          }
        }
        .divider{
          width: 2px; height: 20px;
          background-color: #444;
          margin: 0 4px;
          @media (max-width: 1480px) {
            height: 18px;
          }
        }
      }
      .btnCnt{
        padding: 30px 0 0;
      }
      .socmedCnt{
        padding: 30px 0 0;
        h4{
          margin: 0 0 14px;
          font-size: 18px;
          @media (max-width: 1480px) {
            font-size: 17px;
          }
        }
        p{
          font-size: 16px;
          margin: 0;
          @media (max-width: 1480px) {
            font-size: 15px;
          }
        }
        .media-sosial-icon-container{
          display: flex;
          justify-content: center;
          padding: 10px 0 0;
          .media-sosial-icon{
            font-size: 30px;
            margin: 0 5px;
            border-radius: 50%;
            overflow: hidden;
            img{
              height: 40px;
              display: block;
            }
          }
        }
        .comunityCnt{
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          @media (max-width: 740px) {
            justify-content: center;
          }
          li{
            list-style: none;
            a{
              display: block;
              width: 36px; height: 36px;
              border-radius: 50%;
              box-sizing: border-box;
              margin-right: 10px;
              opacity: 1;
              background-size: 36px auto;
              background-position: center;
              background-repeat: no-repeat;
              transition: all .3s ease;
              &:hover{
                box-shadow: 2px 2px 4px rgba(0, 0, 0, .3);
              }
              &.wa{
                background-image: url(../assets/ic-whatsapp.png);
              }
              &.tw{
                background-image: url(../assets/ic-twitter.png);
              }
              &.fb{
                background-image: url(../assets/ic-facebook.png);
              }
              &.flicker{
                background-image: url(../assets/ic-flickr.png);
              }
              &.yt{
                background-image: url(../assets/ic-youtube.png);
              }
              &.sp{
                background-image: url(../assets/ic-spotify.png);
              }
              &.li{
                background-image: url(../assets/ic-linkedin.png);
              }
              &.ig{
                background-image: url(../assets/ic-instagram.png);
              }
              &.icel{
                background-color: #fff;
                background-image: url(../assets/Icon-main.svg);
                background-size: 24px auto;
              }
              &.journal{
                background-color: #fff;
                background-image: url(../assets/Icon-journal.svg);
                background-size: 28px auto;
              }
              &.library{
                background-color: #fff;
                background-image: url(../assets/Icon-library.svg);
                background-size: 22px auto;
              }
            }
          }
        }
      }
    }
  }
}
</style>
